module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12 2l-5.5 9h11z\"></path><circle cx=\"17.5\" cy=\"17.5\" r=\"4.5\"></circle><path d=\"M3 13.5h8v8H3z\"></path><path fill=\"none\" d=\"M0 0h24v24H0z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/assets/svg/category.vue.svg
// module id = XZNQ
// module chunks = 1